import { Accordion, AccordionHeader, AccordionItem, AccordionPanel, Text } from '@fluentui/react-components';
import { observer } from 'mobx-react-lite';
import { useState } from 'react';
import { useStores } from '../../../common/hooks';
import { AwardGroupRef } from '../../../models';
import './AccordionView.scss';

interface AccordionViewProps {
  onAwardSelected(award: AwardGroupRef): void;
}

const AccordionViewImpl: React.FC<AccordionViewProps> = (props) => {
  const {
    onAwardSelected,
  } = props;

  const {
    selectAwardPageUiStore,
  } = useStores();

  const [activeGroupId, setActiveGroupId] = useState<string>();

  return (
    <div className='accordion-view'>
      <Accordion
        collapsible
      >
        {
          selectAwardPageUiStore.awardGroups.map((awardGroup, index) => {
            const key = awardGroup.awardGroupId.toString();
            return (
              <AccordionItem
                value={index + 1}
                key={`award-group-${key}`}
              >
                <AccordionHeader
                  onClick={() => key === activeGroupId ? setActiveGroupId(undefined) : setActiveGroupId(key)}
                  className={key === activeGroupId ? 'active' : ''}
                >
                  <Text
                    weight='semibold'
                  >
                    {awardGroup.title}
                  </Text>
                </AccordionHeader>
                <AccordionPanel
                  className='accordion-view__panel'
                >
                  {
                    awardGroup.awards.map(award => {
                      return (
                        <button
                          onClick={() => onAwardSelected(award)}
                          key={award.awardId.toString()}
                          className={selectAwardPageUiStore.isEligibleAward(award.awardId) ? '' : 'not-eligible'}
                        >
                          {award.title}
                        </button>
                      )
                    })
                  }
                </AccordionPanel>
              </AccordionItem>
            );
          })
        }
      </Accordion>
    </div>
  );
}

export const AccordionView = observer(AccordionViewImpl);
